<cb-dialog class="flex-fill lot-migrator-dialog" dialogHeading="Migrate Lots" [fullscreen]="true">
    <mat-stepper
        class="lot-migrator-stepper"
        orientation="vertical"
        [linear]="true"
        labelPosition="bottom"
        #stepper
    >
        <mat-step [stepControl]="sourceSelectionControl">
            <ng-template matStepLabel>Select Lots to Migrate</ng-template>
            <cb-lot-migrator-source-selection
                [groups]="migrationLots"
                [maxLotsToMigrate]="maxLotsToMigrate"
                (selectionChange)="handleSelectedLotsChange($event)"
                (lotTypeChange)="handleSelectedLotTypeChange($event)"
            ></cb-lot-migrator-source-selection>
        </mat-step>
        <mat-step [completed]="lots.length > 0 && lotType != null">
            <ng-template matStepLabel>Set number of new Lots</ng-template>
            <cb-lot-migrator-source-summary
                [lots]="lots"
                [lotType]="lotType"
            ></cb-lot-migrator-source-summary>
            <cb-lot-migrator-target-config
                [migrationLotType]="migrationLotType"
                [rebuildTrigger]="targetConfigRebuildTrigger"
                (lotAddMapChange)="handleLotAddMapChange($event)"
            ></cb-lot-migrator-target-config>
        </mat-step>
        <mat-step [stepControl]="lotsFormArray">
            <ng-template matStepLabel>Review Lot Details</ng-template>
            <cb-lot-migrator-lot-forms
                [migrationLotType]="migrationLotType"
                [lotAddMap]="lotAddMap"
                [lotMappedItems]="lotMappedItems"
                [unavailableLotNumbers]="unavailableLotNumbers"
                [addressRegions]="addressRegions"
                [buildTypes]="buildTypes"
                [contractTypes]="contractTypes"
                [lotTypes]="lotTypes"
                (formsChange)="handleFormsChange($event)"
                (sourceDestinationMappingChange)="handleSourceDestinationMappingChange($event)"
            ></cb-lot-migrator-lot-forms>
        </mat-step>
        <mat-step
            optional
            [hasError]="hasInvalidLotDetails(stepper.selectedIndex)"
            [errorMessage]="lotMigratorErrorMessage.invalidLotDetails"
        >
            <ng-template matStepLabel>Select Documents to Migrate</ng-template>
            <cb-lot-migrator-document-selector
                [lotMappedItems]="lotMappedItems"
                [lotType]="lotType"
                [lotPermissions]="lotPermissions"
                [systemArea]="systemArea"
                (selectionUpdated)="handleDocumentSelectionUpdated($event)"
            ></cb-lot-migrator-document-selector>
        </mat-step>
        <mat-step [stepControl]="documentAssignmentsFormArray" [optional]="!hasSelectedDocuments">
            <ng-template matStepLabel>Select the destination for the selected documents</ng-template>
            <cb-lot-migrator-document-assignments
                [lots]="lots"
                [lotNumbers]="lotNumbers"
                [lotSelectedDocuments]="lotSelectedDocuments"
                [sourceToDestinationLotNumberMap]="sourceToDestinationLotNumberMap"
                (assignmentsChange)="handleAssignmentsChange($event)"
                (assignmentsFormChange)="handleAssignmentsFormChange($event)"
            ></cb-lot-migrator-document-assignments>
        </mat-step>
        <mat-step
            [hasError]="hasInvalidDocumentAssignments(stepper.selectedIndex)"
            [errorMessage]="lotMigratorErrorMessage.invalidDocumentAssignments"
        >
            <ng-template matStepLabel>Review Changes</ng-template>
            <cb-lot-migrator-review
                [cancelledLots]="cancelledLots"
                [newLotSummaries]="newLotSummaries"
                [docAssignments]="docAssignments"
            ></cb-lot-migrator-review>
        </mat-step>
    </mat-stepper>
    <div actions>
        <button mat-raised-button (click)="cancel()">Close</button>
        <button
            mat-flat-button
            color="primary"
            [disabled]="stepper.selectedIndex !== lotMigratorStepIndex.ReviewChanges"
            (click)="openExecutionPanel()"
        >
            Confirm
        </button>
    </div>
</cb-dialog>
